'use client';

import { toast, Toaster as SonnerToaster } from 'sonner';
import type { ComponentProps } from 'react';

type ToasterProps = ComponentProps<typeof SonnerToaster>;

const Toaster = (props: ToasterProps) => {
  return (
    <SonnerToaster
      position="top-center"
      richColors
      closeButton
      duration={10000}
      style={
        {
          '--toast-icon-margin-start': '0px',
          '--toast-icon-margin-end': '8px',
        } as React.CSSProperties
      }
      toastOptions={{
        style: {
          alignItems: 'flex-start',
        },
        classNames: {
          icon: 'mt-[2px]',
        },
      }}
      {...props}
    />
  );
};

export type ShowNotificationParams = {
  title: string;
  message?: string;
  valid: boolean;
};

const showNotification = ({ title, message, valid }: ShowNotificationParams) => {
  if (valid) {
    toast.success(title, { description: message });
  } else {
    toast.error(title, { description: message });
  }
};

export { Toaster, showNotification, toast };
